import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IStudentImportPreview, IStudentImportResult } from '../interfaces/student-import';

@Injectable({
  providedIn: 'root',
})
export class StudentImportService {
  constructor(private httpClient: HttpClient) {}

  previewImport(url: string, formData: FormData): Observable<IStudentImportPreview> {
    return this.httpClient.post<IStudentImportPreview>(url, formData, {
      headers: { accept: '*/*' },
    }) as Observable<IStudentImportPreview>;
  }

  confirmImport(url: string, batchId: string): Observable<IStudentImportResult> {
    return this.httpClient.post<IStudentImportResult>(
      url,
      { batch_id: batchId },
      { headers: { accept: '*/*' } },
    ) as Observable<IStudentImportResult>;
  }
}
